import { assertNever } from "@redotech/util/type";
import { ReportDataType } from "../report-data-type";

export enum ReportFilterType {
  RETURN_TYPE = "returnType",
  ORDER_CREATED_DATE = "orderCreatedDate",
  // ORDER_DELIVERY_DATE = "orderDeliveryDate",
  RETURN_CREATED_DATE = "returnCreatedDate",
  RETURN_DELIVERY_DATE = "returnDeliveryDate",
  RETURN_APPROVAL_DATE = "returnApprovalDate",
  RETURN_PROCESSED_DATE = "returnProcessedDate",
  // PURCHASED_REDO = "purchasedRedo",
  RETURN_STATUS = "returnStatus",
  RETURN_METHOD = "returnMethod",
  COMPENSATION_METHODS = "compensationMethods",

  PRODUCT_PROCESSED_DATE = "productProcessedDate",
  PRODUCT_STATUS = "productStatus",
  COMPENSATION_METHOD = "compensationMethod",
  PRODUCT_NAME = "productName",
  VARIANT_NAME = "variantName",

  ORDER_PROCESSED_DATE = "orderProcessedDate",
  PRODUCT_TYPE = "productType",
  TAGS = "tags",

  COUNTRY_CODE = "countryCode",
}

export const RETURNS_REPORT_FILTER_TYPES = [
  ReportFilterType.RETURN_TYPE,
  ReportFilterType.ORDER_CREATED_DATE,
  // ReportFilterType.ORDER_DELIVERY_DATE,
  ReportFilterType.RETURN_CREATED_DATE,
  ReportFilterType.RETURN_DELIVERY_DATE,
  // ReportFilterType.APPROVAL_DATE,
  ReportFilterType.RETURN_PROCESSED_DATE,
  // ReportFilterType.PURCHASED_REDO,
  ReportFilterType.RETURN_STATUS,
  ReportFilterType.RETURN_METHOD,
  ReportFilterType.COMPENSATION_METHODS,
  ReportFilterType.COUNTRY_CODE,
] as const;

export function isValidReturnsReportFilterType(
  type: ReportFilterType | string,
): type is (typeof RETURNS_REPORT_FILTER_TYPES)[number] {
  return (RETURNS_REPORT_FILTER_TYPES as readonly string[]).includes(type);
}

export const RETURNED_LINE_ITEMS_REPORT_FILTER_TYPES = [
  ReportFilterType.RETURN_TYPE,
  ReportFilterType.ORDER_CREATED_DATE,
  // ReportFilterType.ORDER_DELIVERY_DATE,
  ReportFilterType.RETURN_CREATED_DATE,
  ReportFilterType.RETURN_STATUS,
  ReportFilterType.RETURN_METHOD,
  ReportFilterType.RETURN_DELIVERY_DATE,
  ReportFilterType.RETURN_APPROVAL_DATE,
  ReportFilterType.RETURN_PROCESSED_DATE,
  ReportFilterType.PRODUCT_PROCESSED_DATE,
  ReportFilterType.PRODUCT_STATUS,
  ReportFilterType.COMPENSATION_METHOD,
  ReportFilterType.PRODUCT_NAME,
  ReportFilterType.VARIANT_NAME,
  ReportFilterType.COUNTRY_CODE,
] as const;

export function isValidReturnedLineItemsReportFilterType(
  type: ReportFilterType | string,
): type is (typeof RETURNED_LINE_ITEMS_REPORT_FILTER_TYPES)[number] {
  return (
    RETURNED_LINE_ITEMS_REPORT_FILTER_TYPES as readonly string[]
  ).includes(type);
}

export const ORDERED_LINE_ITEMS_REPORT_FILTER_TYPES = [
  ReportFilterType.ORDER_PROCESSED_DATE,
  ReportFilterType.PRODUCT_NAME,
  ReportFilterType.PRODUCT_TYPE,
  ReportFilterType.TAGS,
  ReportFilterType.VARIANT_NAME,
  ReportFilterType.COUNTRY_CODE,
] as const;

export function isValidOrderedLineItemsReportFilterType(
  type: ReportFilterType | string,
): type is (typeof ORDERED_LINE_ITEMS_REPORT_FILTER_TYPES)[number] {
  return (ORDERED_LINE_ITEMS_REPORT_FILTER_TYPES as readonly string[]).includes(
    type,
  );
}

export const WARRANTY_CUSTOMERS_REPORT_FILTER_TYPES = [] as const;

export function isValidWarrantyCustomersReportFilterType(
  type: ReportFilterType | string,
): type is (typeof WARRANTY_CUSTOMERS_REPORT_FILTER_TYPES)[number] {
  return (WARRANTY_CUSTOMERS_REPORT_FILTER_TYPES as readonly string[]).includes(
    type,
  );
}

export const PURCHASED_EXTENDED_WARRANTY_REPORT_FILTER_TYPES = [] as const;

export function isValidPurchasedExtendedWarrantyReportFilterType(
  type: ReportFilterType | string,
): type is (typeof PURCHASED_EXTENDED_WARRANTY_REPORT_FILTER_TYPES)[number] {
  return (
    PURCHASED_EXTENDED_WARRANTY_REPORT_FILTER_TYPES as readonly string[]
  ).includes(type);
}

export function getValidFilterTypes(
  dataType: ReportDataType,
): ReportFilterType[] {
  switch (dataType) {
    case ReportDataType.RETURNS:
      return [...RETURNS_REPORT_FILTER_TYPES];
    case ReportDataType.RETURNED_LINE_ITEMS:
      return [...RETURNED_LINE_ITEMS_REPORT_FILTER_TYPES];
    case ReportDataType.ORDERED_LINE_ITEMS:
      return [...ORDERED_LINE_ITEMS_REPORT_FILTER_TYPES];
    case ReportDataType.WARRANTY_CUSTOMERS:
      return [...WARRANTY_CUSTOMERS_REPORT_FILTER_TYPES];
    case ReportDataType.PURCHASED_EXTENDED_WARRANTY:
      return [...PURCHASED_EXTENDED_WARRANTY_REPORT_FILTER_TYPES];
    default:
      assertNever(dataType);
  }
}
